import { logError } from '@ecomm/error-handling'
import { setPartnerCookie } from '@ecomm/shared-cookies'
import { IOCreateOrSetPartnerAssociationCart } from '@simplisafe/ss-ecomm-data/cart'
import { getLocalStorageCartIdAsString } from '.'

type PartnerLogicProps = {
  readonly partnerGroup: string
  readonly partnerName: string
  readonly partnerUrl: string
  readonly dispatch: ({}) => void
  readonly partnerMemberId?: string
}

export const setPartnerLogic = ({
  partnerGroup,
  partnerName,
  partnerUrl,
  dispatch,
  partnerMemberId
}: PartnerLogicProps) => {
  setPartnerCookie({
    partnerGroup,
    partnerName,
    partnerUrl,
    partnerMemberId
  })

  const cartId = getLocalStorageCartIdAsString()

  dispatch(
    IOCreateOrSetPartnerAssociationCart(partnerGroup, partnerName, cartId, () =>
      logError(
        Error('there was an error when adding a partner association to cart')
      )
    )
  )
}
